export default __webpack_public_path__ + "static/ES_Emergency-Kit-4492477635ed9faf3fbb7e53fade46dd.svg";